module.exports = __webpack_public_path__ + "img/kuzatuv.2b0ec4a5.png";